import { isLocalStorageAvailable } from "../../util";

export default {
  namespaced: true,
  state: {
    serverUrl: "",
    wsOnly: false,
    path: "/socket.io",
    namespace: "",
    parser: "default",
    socketId: "",
    connectedAt: null,
    connected: false,
    connecting: true,
    connectionError: null,
  },
  mutations: {
    init(state) {
      if (isLocalStorageAvailable)
        state.socketId = localStorage.getItem("socket_id");
    },
    saveSocketId(state, socketId) {
      state.socketId = socketId;
      if (isLocalStorageAvailable) {
        localStorage.setItem("socket_id", socketId);
      }
    },
    saveConfig(state, { serverUrl, wsOnly, path, namespace, parser }) {
      state.serverUrl = serverUrl;
      state.wsOnly = wsOnly;
      state.path = path;
      state.namespace = namespace;
      state.parser = parser;
      if (isLocalStorageAvailable) {
        localStorage.setItem("server_url", serverUrl);
        localStorage.setItem("ws_only", wsOnly);
        localStorage.setItem("path", path);
        localStorage.setItem("namespace", namespace);
        localStorage.setItem("parser", parser);
      }
    },
    tryConnect(state) {
      state.connecting = true;
      state.connectionError = null;
    },
    setConnectionError(state, error) {
      state.connectionError = error;
    },
    connect(state, { socketId, timestamp }) {
      state.connected = true;
      state.socketId = socketId;
      state.connectedAt = timestamp;
      state.connecting = false;
    },
    disconnect(state) {
      state.connected = false;
      state.socketId = null;
      state.connectedAt = null;
      state.connecting = false;
    },
  },
};
